import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAgent: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAgent"><Circle cx="12" cy="6" r="2.75" stroke="currentColor" strokeWidth="1.5"/><Circle cx="6" cy="18" r="2.75" stroke="currentColor" strokeWidth="1.5"/><Circle cx="18" cy="18" r="2.75" stroke="currentColor" strokeWidth="1.5"/><Path d="M12 9V12M12 12H9C7.34315 12 6 13.3431 6 15M12 12H15C16.6569 12 18 13.3431 18 15" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAgent;
